export { WMultiTextInput as default } from "./WMultiTextInput";